import apiV2Service from 'common/src/modules/api/api-v2.service';
import {GetContentFeedItemsResponse} from 'common/src/modules/contentFeedItems/contentFeedItems.types';
import {FeedItem} from '../feedItems/feedItems.types';

const BASE_PATH = 'ContentItems';

async function getFeedItems(feedId: number) {
  return apiV2Service
    .executeGetRequest<GetContentFeedItemsResponse>(`${BASE_PATH}/Feed/${feedId}`)
    .then(({data: reponse}) => reponse);
}

async function getFeedItemsByIds(feedId: number, itemIds: string[]) {
  const {
    data: {items},
  } = await apiV2Service.executePostRequest<{items: FeedItem[]}>(
    `${BASE_PATH}/Feed/${feedId}/GetByIds`,
    {},
    {itemIds},
  );

  return items;
}

export const contentFeedItemsApi = {
  getFeedItems,
  getFeedItemsByIds,
};
